import { Button, DatePicker } from 'antd'
import { styled } from 'styled-components'

export const Line = styled.div`
  height: 1px;
  background-color: black;
  margin-bottom: 30px;
  width: 30%;
`

export const Container = styled.div`
  display: flex;
  width: 80%;
  justify-content: center;
`

export const DataCellWrapper = styled.td<{ position?: string; isError?: boolean }>`
  border: 1px solid;
  text-align: ${({ position }) => (position ? position : 'right')};
  padding: 5px;
  background-color: ${({ isError }) => isError && '#f291f1'};
  width: 100px;
`

export const SelectWrapper = styled.div<{ marginLeft?: string; width?: string }>`
  display: flex;
  border: 1px solid;
  justify-content: space-between;
  width: ${({ width }) => (width ? width : '200px')};
  height: 35px;
  margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '30px')};
`

export const HeaderCellWrapper = styled.th`
  border: 1px solid;
  text-align: center;
  background-color: #e2eff9;
  width: 100px;
  height: 56px;
`

export const TableCustom = styled.table`
  table-layout: fixed;
  width: 100%;

  .item_click {
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
  }
`

export const Wrappertable = styled.div`
  position: relative;
  margin-top: 20px;
  .ant-table-thead .ant-table-cell.active {
    background-color: #a8c0f5 !important;
    border-bottom: 1px solid #a8c0f5 !important;
  }

  td .error {
    padding: 0 5px;
    background: #fe65ffbf !important;
  }

  td .success {
    padding: 0 5px;
  }

  td {
    padding: 0 !important;
    border: 1px solid;
    border-left: none;
  }

  th {
    background: #e2eff9 !important;
    border: 1px solid;
    border-left: none;
    padding: 0 15px !important;
  }
`

export const WrapperSearch = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
export const SelectEmployee = styled.div`
  display: flex;
  border: 1px solid;
  justify-content: space-between;
  height: 35px;
  margin-left: 30px;
  margin-bottom: 10px;
`

export const ButtonCustom = styled(Button)`
  margin-left: 30px;
  height: 35px;
  border: 1px solid;
`

export const ButtonWrapper = styled.div`
  display: flex;
`

export const DatePickerCustom = styled(DatePicker)`
  display: block;
  border: none !important;
`

export const SearchDayWrapper = styled.div<{ margin_bottom?: string }>`
  display: flex;
  border: 1px solid;
  width: 100%;
  justify-content: space-between;
  margin-bottom: ${({ margin_bottom }) => (margin_bottom ? `${margin_bottom}px` : '10px')};
`

export const TitleSearch = styled.div<{ width?: string }>`
  width: ${({ width }) => (width ? width : 'auto')};
  padding: 0 5px;
  font-size: 16px;
  display: flex;
  align-items: center;
  border-right: 1px solid;
`

export const ButtonCustoms = styled(Button)`
  border: 1px solid;
  margin-bottom: 20px;
  float: right;
`
export const ButtonCreate = styled(Button)`
  border: 1px solid;
  margin-bottom: 10px;
  right: 0;
  float: right;
`
